import { getDefaultExportFromCjs as r } from "./index.es469.js";
import { __require as o } from "./index.es470.js";
var t = o();
const m = /* @__PURE__ */ r(t);
export {
  m as default
};
//# sourceMappingURL=index.es422.js.map
